import React,{useState,useEffect} from 'react';
import Axios from 'axios';
import LoaderCircle from './LoaderCircle';

const ConfirmDialog=({confirmFunc,cancelFunc,children})=>{
    const [isLoading, setIsloading]=useState(false);

    const doSubmit=()=>{
        setIsloading(true);
        confirmFunc();
    }

    return(
        <div id="reset-settings-confirm" tabIndex="-1" className="fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-full max-h-full alim-modal flex justify-center items-center bg-light-blue/50">
            <div className="relative p-4 w-full max-w-md max-h-full">
                <div className="relative alim-modal-bg-color-style rounded-lg shadow">
                    {
                        !isLoading&&
                        <button type="button" className="absolute top-3 end-2.5 modal-close-btn rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center" onClick={()=>{cancelFunc(false)}}>
                            <span className="modal-close-img-elem w-[12px] h-[12px]"></span>
                            <span className="sr-only">Close modal</span>
                        </button>
                    }
                    <div className="p-4 md:p-5 text-center">
                        <div className="info-img-elem w-[48px] h-[48px] mx-auto my-3"></div>
                        {children}
                        {
                            isLoading?
                                <LoaderCircle/>
                            :
                                <>
                                    <button type="button" className="text-white bg-deep-red font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center me-2" onClick={doSubmit}>
                                        Yes, I'm sure
                                    </button>
                                    <button type="button" className="text-white bg-dark_blue rounded-lg text-sm font-medium px-5 py-2.5" onClick={()=>{cancelFunc(false)}}>
                                        No, Cancel
                                    </button>
                                </>
                        }
                        
                        
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConfirmDialog;